// Noodl SDK - webpack handles this require properly
const Noodl = require('@noodl/noodl-sdk');
const React = require('react');
import { CustomButton } from '@shared/components/CustomButton/CustomButton';

export const CustomButtonNode = Noodl.defineReactNode({
  name: 'Prodikt Custom Button',
  displayName: 'Custom Button',
  category: 'Prodikt Components',
  
  getReactComponent() {
    return CustomButton;
  },

  inputProps: {
    // Content
    text: {
      type: 'string',
      displayName: 'Text',
      group: 'General'
    },

    // State
    isDisabled: {
      type: 'boolean',
      displayName: 'Disabled',
      default: false,
      group: 'General'
    },

    // Variants
    variant: {
      type: {
        name: 'enum',
        enums: [
          { label: 'Primary', value: 'primary' },
          { label: 'Secondary', value: 'secondary' },
          { label: 'Outline', value: 'outline' },
          { label: 'Ghost', value: 'ghost' }
        ]
      },
      displayName: 'Variant',
      default: 'primary',
      group: 'Style'
    },

    size: {
      type: {
        name: 'enum',
        enums: [
          { label: 'Small', value: 'small' },
          { label: 'Medium', value: 'medium' },
          { label: 'Large', value: 'large' }
        ]
      },
      displayName: 'Size',
      default: 'medium',
      group: 'Style'
    },

    // Layout
    fullWidth: {
      type: 'boolean',
      displayName: 'Full Width',
      default: false,
      group: 'Layout'
    },

    // Styling
    className: {
      type: 'string',
      displayName: 'CSS Class',
      group: 'Style'
    },
    hasNoRadius: {
      type: 'boolean',
      displayName: 'No Border Radius',
      default: false,
      group: 'Style'
    },
    hasNoBoxShadow: {
      type: 'boolean',
      displayName: 'No Box Shadow',
      default: false,
      group: 'Style'
    }
  },

  outputProps: {
    onPress: {
      type: 'signal',
      displayName: 'Pressed'
    },
    onHoverStart: {
      type: 'signal',
      displayName: 'Hover Start'
    },
    onHoverEnd: {
      type: 'signal',
      displayName: 'Hover End'
    }
  },

  setup: function() {
    // Handle props initialization
  },

  initialize: function() {
    // Set up onPress handler
    this.props.onPress = () => {
      this.sendSignalOnOutput('onPress');
    };

    // Set up onHoverStart handler
    this.props.onHoverStart = () => {
      this.sendSignalOnOutput('onHoverStart');
    };

    // Set up onHoverEnd handler
    this.props.onHoverEnd = () => {
      this.sendSignalOnOutput('onHoverEnd');
    };
  }
});
